import React, { useState } from "react";
import { Box, Card, Grid, TextField , IconButton , InputAdornment} from "@mui/material";
import { Col, Row } from "react-bootstrap";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import ApiService from "../../functions/apiService";
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import HeaderRoutes from "../../components/HeaderRoutes/HeaderRoutes";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import UserSettingsHeader from "../../components/HeadersNav/userSettingsHeader";

const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
	const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
	const navigate = useNavigate();

  const changePassword = () => {
    const body = {
      "old_password": oldPassword,
      "password": newPassword,
      "password_confirmation": confirmPassword
    }
    ApiService.post('/changePassword', body)
      .then((data) => {
        toast.success(data.message)
        setOldPassword('')
        setNewPassword('')
        setConfirmPassword('')
		    navigate('/firehouse/calendar');

      })
      .catch((error) => {
        if (error.status == 422) {
          if (error.data.message) {
            toast.error(error.data.message)
          }
          else {
            Object.keys(error.data.errors).map((err) => (
              toast.error(error.data.errors[err][0])
            ))
          }
        }
        else {
          toast.error(error.data.message)
        }
      })
  }

  return (
    <>
			<UserSettingsHeader />
      <Card className="shadow p-3 my-3">
				<div style={{display:'flex' , alignItems:'center'}}> 
					<h6 className="fs-5 fw-600 my-2 me-2">Change Password</h6>
					<img src='/images/change-password.svg' height='26px' width='26px'/>
				</div>
        <Box className="my-2">
          <Row className="mt-4">
            <Col md={3}>
              <TextField
                className='w-100'
                color='secondary'
                variant="outlined"
                label="Current Password"
                type={showOld ? "text" : "password"}
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                InputProps={{
									sx: {
										height: '54px',
										fontSize: '14px',
									},
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowOld(!showOld)}
                        edge="end"
                      >
                        {showOld ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Col>
            <Col md={3}>
              <TextField
                className='w-100'
                color='secondary'
                variant="outlined"
                label="New Password"
                type={showNew ? "text" : "password"}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                InputProps={{
									sx: {
										height: '54px',
										fontSize: '14px',
									},
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowNew(!showNew)}
                        edge="end"
                      >
                        {showNew ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Col>
            <Col md={3}>
              <TextField
								className="w-100"
								color="secondary"
								variant="outlined"
								label="Confirm Password"
								type={showConfirm ? "text" : "password"}
								value={confirmPassword}
								onChange={(e) => setConfirmPassword(e.target.value)}
								InputProps={{
									sx: {
										height: '54px',
										fontSize: '14px',
									},
									endAdornment: (
										<InputAdornment position="end">
											<IconButton
												onClick={() => setShowConfirm(!showConfirm)}
												edge="end"
											>
												{showConfirm ? <Visibility /> : <VisibilityOff />}
											</IconButton>
										</InputAdornment>
									),
								}}
							/>
            </Col>
						<Col md={3}>
							<img src="/images/change-password-img.jpg" height='200px' width='300px' style={{marginTop:'-65px'}}/>
						</Col>
          </Row>
          <div style={{marginTop:'-60px'}}>
            <ButtonTheme type='submit' variant='filled' color='primary' className='px-5 mt-3'
              onClick={changePassword} disabled={!oldPassword || !newPassword || !confirmPassword} >
              Update
            </ButtonTheme>
          </div>
        </Box>
      </Card>
    </>
  )
}
export default ChangePassword